// extracted by mini-css-extract-plugin
export default {"chart-container":"GaugeChart_chart-container__TurT1","total-count":"GaugeChart_total-count__nqyF6","title":"GaugeChart_title__hl4R6"};